import React, { useState } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { get, size, isNumber } from 'lodash'

import Button from './Button'

import styles from './NotesEntryModal.module.scss'

const NotesEntryModal = ({ className, initialValue, characterMax, onCancel, onSubmit }) => {
  const classNames = cn(styles.notesEntryModal, className)
  const [notes, setNotes] = useState(initialValue)
  const hasCharacterMax = isNumber(characterMax)
  const characterCount = size(notes)
  const characterCountString = `${characterCount}${hasCharacterMax ? `/${characterMax}` : ''}`

  const handleSetNotes = (event) => {
    const notes = get(event, 'target.value', '')
    let trimmedNotes = notes

    if (hasCharacterMax) {
      trimmedNotes = notes.substring(0, characterMax)
    }

    setNotes(trimmedNotes)
  }

  return (
    <div className={classNames}>
      <div className={styles.overlay}></div>
      <div className={styles.content}>
        <div></div>
        <div className={styles.textFieldContainer}>
          <textarea
            autoFocus
            placeholder="Add Special Instructions"
            value={notes}
            onChange={handleSetNotes}
            className={styles.textField}
          />
        <span className={styles.characterCount}>{characterCountString}</span>
        </div>
        <div className={styles.buttonContainer}>
          <Button onClick={onCancel} className={styles.cancelButton}>CANCEL</Button>
          <Button onClick={() => onSubmit(notes)} className={styles.doneButton}>DONE</Button>
        </div>
      </div>
    </div>
  )
}

NotesEntryModal.defaultProps = {
  initialValue: '',
  characterMax: null,
  onCancel: () => {},
  onSubmit: () => {},
}

NotesEntryModal.propTypes = {
  initialValue: PropTypes.string,
  characterMax: PropTypes.number,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
}

export default NotesEntryModal
